"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
//
// styles
//
const StyledContainer_1 = require("./StyledContainer");
const StyledLink_1 = require("./StyledLink");
const TabNavigation = (props) => {
    return (react_1.default.createElement(StyledContainer_1.StyledContainer, { className: 'settings-nav' }, props.tabs.map(({ label, link, description }) => (react_1.default.createElement("div", { className: 'nav-item', key: label },
        react_1.default.createElement(StyledLink_1.StyledLink, { className: `nav-link ${description}`, role: 'link', to: link }, label))))));
};
TabNavigation.propTypes = {
    tabs: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        description: prop_types_1.default.string,
        label: prop_types_1.default.string,
        link: prop_types_1.default.string
    }))
};
exports.default = TabNavigation;
